import { RoleGuard } from '@shared/providers/src/MeProvider'
import { UserRole } from '@shared/utils'

import { useWebPushListener } from '@hooks/useWebPush'

import AdminNotifications from './AdminNotifications'
import Appointments from './Appointments'
import AsyncMessagingAppointments from './AsyncMessagingAppointments'
import Files from './Files'
import { useUserNotifications } from './Notifications.hooks'
import OnDemandAppointments from './OnDemandAppointments'
import OutsideOfBusinessHoursPopup from './OutsideOfBusinessHoursPopup'
import PlatformNotifications from './PlatformNotifications'
import ReminderNotifications from './ReminderNotifications'
import ROIMedicalRecordGenerated from './ROIMedicalRecordGenerated'
import SOPsUpdates from './SOPsUpdates'
import UserNotifications from './UserNotifications'

export default function Notifications() {
  useUserNotifications()
  useWebPushListener()

  return (
    <>
      <UserNotifications />
      <Files />
      <RoleGuard prohibited={[UserRole.CBO, UserRole.Pharmacy, UserRole.PharmacyManager]}>
        <SOPsUpdates />
      </RoleGuard>
      <RoleGuard allowed={[UserRole.Provider]}>
        <Appointments />
        <OutsideOfBusinessHoursPopup />
      </RoleGuard>
      <RoleGuard allowed={[UserRole.Provider, UserRole.Admin]}>
        <OnDemandAppointments />
        <AsyncMessagingAppointments />
      </RoleGuard>
      <RoleGuard allowed={[UserRole.MA]}>
        <ROIMedicalRecordGenerated />
      </RoleGuard>
      <RoleGuard allowed={[UserRole.Admin]}>
        <AdminNotifications />
      </RoleGuard>
      <PlatformNotifications />
      <ReminderNotifications />
    </>
  )
}
